module.exports = __webpack_public_path__ + "img/NewsCenterDetails3_pic2.cd116c96.png";